import PreviewOverlayBase from "./shared/preview_overlay_base"

// Inline image lightbox. Attach to a link/element pointing at an image attachment.
// On click it intercepts the navigation and shows the image centered in a fixed
// overlay. Overlay chrome, close handling and teardown come from
// shared/preview_overlay_base; only the image itself is added here.
//
// Usage:
//   <a href="<%= rails_blob_path(blob, disposition: 'inline') %>"
//      data-controller="attachment-preview"
//      data-action="click->attachment-preview#open"
//      data-attachment-preview-url-value="<%= rails_blob_path(blob, disposition: 'inline') %>"
//      data-attachment-preview-filename-value="<%= blob.filename %>"
//      data-attachment-preview-download-url-value="<%= rails_blob_path(blob, disposition: 'attachment') %>"
//      data-attachment-preview-i18n-download-value="<%= t('shared.preview.download') %>"
//      data-attachment-preview-i18n-close-value="<%= t('shared.preview.close') %>">
//     <%= blob.filename %>
//   </a>
export default class extends PreviewOverlayBase {
  // The image sizes itself; the panel must not force a white full-width box
  // around it the way the paged document preview does.
  get bodyClass() {
    return "flex max-h-[85vh] max-w-full items-center justify-center"
  }

  renderBody(body) {
    const img = document.createElement("img")
    img.src = this.urlValue
    img.alt = this.filenameValue || ""
    img.className = "max-h-[85vh] max-w-full rounded bg-white object-contain shadow-2xl"
    body.appendChild(img)
  }
}
